import PatientOverviewPA from 'dashboard/templates/views/Patient/PA/PatientOverviewPA';

import progress from './progress';
import goalSetting from './goal-setting';
import summary from './summary';
import {redirectIfBehaviourModulesAreNotEnabled} from "../../../../../hooks/enabled-module-guard";

/**
 * Start moving routes
 * @name router.Start-moving
 */

const navigationSteps = {
  nextDiscussionStep: {
    PatientRecordPAProgress: 'PatientRecordPAGoalSetting',
    PatientRecordPAGoalSetting: 'PatientRecordProgress',
    PatientRecordPASummary: 'PatientRecordProgress',
  },
  prevDiscussionStep: {
    PatientRecordPAProgress: 'PatientRecordProgress',
    PatientRecordPAGoalSetting: 'PatientRecordPAProgress',
    PatientRecordPASummary: 'PatientRecordPAGoalSetting',
  }
}

export default {
  path: 'physical-activity',
  component: PatientOverviewPA,
  name: 'PatientRecordPA',
  props: navigationSteps,
  redirect: { name: 'PatientRecordPAProgress' },
  meta: {
    // title: 'Patient Record Physical Activity',
    title: t => `${t('patient.patientRecord')} - ${t('screens.startMovingSettingsScreen', 'app_mobile')}`,
    loggedInOnly: true,
  },
  children: [
    progress,
    goalSetting,
    // Note: Release 2.0 scope reduction
    // summary,
  ],
  async beforeEnter(to, from, next) {
    // If user was redirected from page because startmoving is not enabled, don't do anything.
    if (await redirectIfBehaviourModulesAreNotEnabled(["STARTMOVING"], to, next)){
      return
    }

    next();
  },
};
